
import dialogReducers from './dialogs/dialog-reducers';
import steppers from './steppers/steppers-reducer';
import wizard from './wizard/wizard-reducer';
import supplierWizard from './supplier-wizard/reducer';
import addRateSetWizard from './add-rates-wizard/add-rate-set-wizard-reducer';
import addRatesWizard from './add-rates-wizard/add-rates-wizard-reducer';
import commentBox from './contract-activities-products/comment-reducer';
import contractActivitiesProducts from './contract-activities-products/contract-activities-products-reducer';
import contractingError from './error-reducer';
import massRateChange from './mass-rate-change/mass-rate-change-reducer';
import smallContractTemplateList from './small-template-list/small-template-list-reducer';
import contractList from './contract-list/contract-list-reducer';
import templateList from './template-list/template-list-reducer';
import {
  supplierUpdatesQueue,
} from '../../components/contracting/supplier-updates-queue/__storeFiles__/reducer';
import {
  masterTemplateList,
  createNew,
} from '../../components/contracting/master-template-list/__storeFiles__/reducer';
import {
  masterTemplate,
  editDialog,
  applyMasterToTemplatesReducer,
  finaliseDialog,
} from '../../components/contracting/master-template/__storeFiles__/reducer';
import sendToPartners from './send-to-partners/reducer';
import { combineReducers } from 'redux';
import { contractPeriods, currentYear, downloadDocs } from './misc-reducers';

export default combineReducers({
  templateList,
  supplierUpdatesQueue,
  masterTemplate: combineReducers({
    docs: masterTemplate,
    editDialog,
    applyMasterToTemplatesReducer,
    finaliseDialog,
    list: masterTemplateList,
    createNew,
  }),
  contractList,
  steppers,
  wizard,
  supplierWizard,
  contractingError,
  massRateChange,
  smallContractTemplateList,
  sendToPartners,
  addRateSetWizard,
  addRatesWizard,
  contractActivitiesProducts,
  commentBox,
  contractPeriods,
  currentYear,
  downloadDocs,
  ...dialogReducers,
});



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contracting-reducer.js